"use strict";
import "lodash";
import { svc_fetchAll, svc_addOne, svc_editOne, svc_deleteOne, svc_search } from "@/services";
import { showServerResponse } from "@/utils/message";
import logger from "@/utils/logger";

const endpointBasePrefix = "inventory/catalog";

const Model = {
	namespace: "m_Catalog",
	state: {
		catalog: [],
	},
	reducers: {
		handleFetchAll(state, { payload: { catalog } }) {
			return { ...state, catalog };
		},
	},
	effects: {
		*fetchAll({ payload }, { call, put }) {
			let catalog = yield call(svc_search, endpointBasePrefix, payload);
			
			_.forEach(catalog, function (row) {
				row.key = row.id;
			});

			yield put({
				type: "handleFetchAll",
				payload: { catalog },
			});

			return catalog;
		},
		*fetchGlobal({ payload }, { call, put }) {
			let catalog = yield call(svc_search, `${endpointBasePrefix}/global/`, payload);
			
			_.forEach(catalog, function (row) {
				row.key = row.id;
			});

			yield put({
				type: "handleFetchAll",
				payload: { catalog },
			});

			return catalog;
		},
		*fetchBrand({ payload }, { call, put }) {
			let catalog = yield call(svc_search, `${endpointBasePrefix}/brand/${payload.brand_id}`);
			
			_.forEach(catalog, function (row) {
				row.key = row.id;
			});

			yield put({
				type: "handleFetchAll",
				payload: { catalog },
			});

			return catalog;
		},
		*addOne({ payload }, { call, put }) {
			payload = _.omit(payload, ["key"]);
			const response = yield call(svc_addOne, endpointBasePrefix, payload, payload.company_name);
			return showServerResponse(response);
		},
		*editOne({ payload }, { call, put }) {
			payload = _.omit(payload, ["key"]);
			const response = yield call(
				svc_editOne,
				endpointBasePrefix,
				payload,
				"id",
				payload.name,
			);
			return showServerResponse(response);
		},
		*deleteOne({ payload }, { call, put }) {
			payload = _.omit(payload, ["key"]);
			const response = yield call(
				svc_deleteOne,
				endpointBasePrefix,
				payload,
				"id",
				payload.name,
			);
			return showServerResponse(response);
		},
	},
	subscriptions: {},
};

export default Model;
